import { defaultFeatureToggles } from '../../constants/featureToggle';
import { FeatureToggleValues } from '../../types/FeatureToggles';
import { GlobalMessages } from '../../types/Messages';
import { messageHooks } from '../messageHooks/messageHooks';

export const featureStateHooks = {
  useFeatureToggles(): FeatureToggleValues {
    return messageHooks.useSubjectState(GlobalMessages.FeatureToggles) || defaultFeatureToggles;
  },
};
